import React, { useState } from 'react';
import _isEmpty from 'lodash-es/isEmpty';
import tw from 'twin.macro';
import { ExclamationTriangleIcon, PhoneIcon } from '@heroicons/react/16/solid';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';
import { formatIntlPhoneNumber } from 'utils/phone/formatIntlPhoneNumber';
import { ROSelect } from 'containers/Eleves/List/Table/Cells/components/ROSelect';
import Input from 'components/Form/Input2';
import { formatPhoneNumber } from 'utils/phone/formatPhoneNumber';

interface Props {
  value?: string;
  onChange: (v: string) => void;
  readonly?: boolean;
}

export function PhoneCell(props: Props) {
  const { onChange, readonly } = props;
  const [value, setValue] = useState<string>(props.value || '');
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const { isValidPhone } = useTranslatedValidation();

  if (isEditing && !readonly) {
    return (
      <Input
        onBlur={() => {
          setIsEditing(false);
          onChange(value);
        }}
        value={value}
        autoFocus
        hasError={!!isValidPhone(value)}
        onChange={v => setValue(v?.target?.value || '')}
      />
    );
  }

  const invalid = isValidPhone(value);

  return (
    <ROSelect
      onClick={() => {
        if (!readonly) {
          setIsEditing(true);
        }
      }}
      cursor="text"
    >
      {!_isEmpty(value) && (
        <a
          href={`tel:${formatIntlPhoneNumber(value)}`}
          css={[tw`inline-flex items-center gap-1`, invalid && tw`text-danger`]}
        >
          {invalid ? (
            // A cause du buttonRootStyle dans le ROSelect, si on ne force pas à text-current
            // l'icone prend la couleur du buttonRootStyle...
            <ExclamationTriangleIcon tw="w-4 h-4 text-current!" />
          ) : (
            <PhoneIcon tw="w-4 h-4 text-current!" />
          )}
          {formatPhoneNumber(value)}
        </a>
      )}
    </ROSelect>
  );
}
